/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import PiPStore, {type PiPContent, type PiPCorner} from '@app/stores/PiPStore';

export function openPiP(content: PiPContent): void {
	PiPStore.open(content);
}

export function closePiP(): void {
	PiPStore.close();
}

export function showFocusedTileMirror(content: PiPContent, corner: PiPCorner = 'top-right'): void {
	PiPStore.showFocusedTileMirror(content, corner);
}

export function hideFocusedTileMirror(): void {
	PiPStore.hideFocusedTileMirror();
}
